import { IBaseIconProps } from "./IBaseIconProps";

/** Two speech bubbles: a conversation with people (the support team's tickets). */
export const ChatBubblesIcon = ({ color = "currentColor" }: IBaseIconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 9.5C15 12.5 12.3 14.5 9 14.5C8.2 14.5 7.4 14.4 6.7 14.1L3.5 15.5L4.4 12.6C3.5 11.7 3 10.7 3 9.5C3 6.5 5.7 4.5 9 4.5C12.3 4.5 15 6.5 15 9.5Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 9.2C19.6 9.9 21 11.5 21 13.5C21 14.6 20.5 15.6 19.7 16.4L20.5 19L17.6 17.8C17 18 16.3 18.1 15.5 18.1C13.4 18.1 11.6 17.3 10.6 16"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
